'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timingMap = exports.transitionClassNames = exports.percentages = exports.directions = exports.sequences = exports.timings = exports.validChildProps = exports.animationProps = exports.propsDefault = exports.translateMap = undefined;

var _Animator = require('../Animator.scss');

var _Animator2 = _interopRequireDefault(_Animator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var top = 'top';
var bottom = 'bottom';
var left = 'left';
var right = 'right';

var micro = 'micro';
var small = 'small';
var medium = 'medium';
var large = 'large';

var percentages = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
var timings = [micro, small, medium, large];
var directions = [top, bottom, left, right];
var sequences = ['default', 'flip', 'reverse', 'reverse-flip'];

var timingMap = {
  micro: 120,
  small: 150,
  medium: 200,
  large: 300
};

var translateMap = {
  to: {
    top: 'top',
    bottom: 'bottom',
    left: 'left',
    right: 'right'
  },
  size: percentages
};

var propsDefault = {
  duration: timingMap[large],
  timing: large,
  sequence: 'default',
  sequenceDelay: 80,
  translate: {
    to: translateMap.to.top,
    size: percentages[5]
  }
};

var animationProps = ['opacity', 'scale', 'height', 'translate', 'width'];
var validChildProps = ['debug', 'sequence', 'timing'].concat(animationProps);
var transitionClassNames = {
  enter: _Animator2.default.enter,
  appear: _Animator2.default.enter,
  enterActive: _Animator2.default.enterActive,
  appearActive: _Animator2.default.enterActive,
  exit: _Animator2.default.exit,
  exitActive: _Animator2.default.exitActive
};

exports.translateMap = translateMap;
exports.propsDefault = propsDefault;
exports.animationProps = animationProps;
exports.validChildProps = validChildProps;
exports.timings = timings;
exports.sequences = sequences;
exports.directions = directions;
exports.percentages = percentages;
exports.transitionClassNames = transitionClassNames;
exports.timingMap = timingMap;